import {Nav, Navbar} from "rsuite";
import {history} from "../../../_helpers";
import logo from "../../../assets/img/logo-secundari.png";
import React, {useEffect} from "react";
import {toggleMenu} from "../../../assets/js/script";
import {useTranslation, withTranslation} from "react-i18next";

// function NavbarNoLogin(props){
function NavbarNoLogin({className = '', showItems = true}) {
    const {t, i18n} = useTranslation();

    const [activeKey, setActiveKey] = React.useState(
        window.location.href.includes("auth/register") ? "alumno" :
            window.location.href.includes("tutorAuth/register") ? "educador" :
                window.location.href.includes("auth/login") ? "login" :
                    window.location.href.includes("default") ? "inicio" : "inicio"
    );

    useEffect(() => {
        showItems && toggleMenu()
    });



    return (
        <>
            {/* <Navbar className={"menuNavHome"}> */}
            <Navbar className={`navbarMenu ${className}`}>
                {/* <div className={"navbar"}> */}
                <div className={"nav-container"}>
                    <Navbar.Brand className={"imgLogo"} onClick={() => history.push("/default/index")}><img
                        className={"imgLogo"} src={logo} alt={""} width={"151"} height={"52"}/></Navbar.Brand>
                    {showItems && <Nav className={"container-menu"}  activeKey={activeKey}>
                        <ul className={"menu-items"}>
                            <li>
                                <Nav.Item className={"itemMenuNav"} eventKey="inicio"
                                          onClick={() => history.push("/default/index")}>
                                    {t("menu.inicio")}
                                </Nav.Item>
                            </li>
                            <li>
                                <Nav.Item className={"itemMenuNav"} eventKey="alumno"
                                          onClick={() => history.push("/auth/register")}>
                                    {t("menu.alumno")}
                                </Nav.Item>
                            </li>
                            <li>
                                <Nav.Item className={"itemMenuNav"} eventKey="educador"
                                          onClick={() => history.push("/tutorAuth/register")}>
                                    {t("menu.educador")}
                                </Nav.Item>
                            </li>
                            <li>
                                <Nav.Item className={"itemNavRounded"} eventKey="login"
                                          onClick={() => history.push("/auth/login")}>
                                    {t("menu.inicia")}
                                </Nav.Item>
                            </li>
                        </ul>
                        <div className={"content-button"}>
                            <input id={"checkboxMenu"} className={"checkbox"} type="checkbox" name=""/>
                            <div className={"hamburger"}>
                                <span className={"line"}></span>
                                <span className={"line"}></span>
                                <span className={"line"}></span>
                            </div>
                        </div>
                    </Nav>}
                </div>
                {/* </div> */}
            </Navbar>
        </>
    );
}

export default withTranslation()(NavbarNoLogin);
